import { render, staticRenderFns } from "./FrameworkSettings.vue?vue&type=template&id=73eb1b7b"
import script from "./FrameworkSettings.vue?vue&type=script&lang=js"
export * from "./FrameworkSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports